
import AppGrid from '@/components/AppDisplay/AppGrid.vue';
import AppCard from '@/components/AppDisplay/AppCard.vue';
import Navigation from '@/components/Navigation.vue';
import { Paths, generateDynamicPath } from '@/router/Paths';
import { Applications } from '@/router/Applications';
import { defineComponent } from 'vue';

export default defineComponent({
  setup() {
    return { Applications, Paths, generateDynamicPath };
  },
  components: { Navigation, AppGrid, AppCard },
});
